<template>
  <div
    class="media"
    :class="{ 'media--container': mediaContainer }"
  >

    <template v-if="isEditMode">
      <div class="media__image">
        <sc-image :media="scImageField || {}" />
      </div>
      <div v-if="videoSource" class="media__video">
        <div class="media__video-placeholder" />
      </div>
    </template>

    <template v-else>
      <div
        class="media__image"
        :class="{ 'media__image--hidden': displayVideo }"
      >
        <slot />
      </div>
      <div v-if="hasVideo" class="media__video">
        <vimeo-video
          v-show="displayVideo"
          :url="videoSource"
          :autoplay="videoAutoplay"
          :mute="videoMute"
          :loop="videoLoop"
          :default-controls="videoDefaultControls"
          :custom-controls="videoCustomControls"
          :hidden-text="videoHiddenText"
          @error="handleVideoError"
          @ready="videoReady = true"
          @play="videoPlaybackStarted = true"
        />
      </div>
    </template>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Image } from '@sitecore-jss/sitecore-jss-vue'
import VimeoVideo from '~/components/sitecore/vimeo-video'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  components: {
    ScImage: Image,
    VimeoVideo
  },

  props: {
    mediaContainer: {
      type: Boolean,
      default: true
    },

    scImageField: {
      type: Object,
      default: () => {}
    },

    videoSource: {
      type: String,
      default: ''
    },

    videoAutoplay: {
      type: Boolean,
      default: true
    },

    videoMute: {
      type: Boolean,
      default: true
    },

    videoLoop: {
      type: Boolean,
      default: false
    },

    videoDefaultControls: {
      type: Boolean,
      default: false
    },

    videoCustomControls: {
      type: Boolean,
      default: false
    },

    videoHiddenText: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      videoFailed: false,
      videoReady: false,
      videoPlaybackStarted: false
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    hasVideo () {
      return this.videoSource && !this.videoFailed
    },

    displayVideo () {
      return this.videoAutoplay ? this.videoPlaybackStarted : this.videoReady
    }
  },

  methods: {
    handleVideoError () {
      this.videoFailed = true
      this.$emit('media-error')
    }
  }
}
</script>

<style lang="scss" scoped>
  $image-fade-transition-duration: 1.5s;

  .media {
    &--container {
      position: relative;

      .media__image {
        position: static;
      }
    }

    &__image {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      transition: opacity $image-fade-transition-duration;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &--hidden {
        opacity: 0;
      }
    }

    &__video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .media__video-placeholder {
    width: 100%;
    height: 100%;
    @include placeholder-image('~assets/images/video-placeholder.png');
  }
</style>
